import { defineComponent as _defineComponent } from 'vue'
import { DataInstance } from '@busy-human/gearbox';
import Modal from '@/components/Modal.vue';
import DogCreator from '@/components/dog-creator.vue';
import { Events, Userspaces } from '@busy-human/k9-library';
import { ref, computed, onUpdated, watch } from 'vue';
import DogCard from './dog-card.vue';
import Dropdown from './dropdown.vue';
import { useDogspace } from '@/store/dogspaces';
import UserNotesPanel from './user-notes-panel.vue';
import { getAgreementUrl, testAddCustomer } from '@/util/functions';
import { useAgreements } from '@/store/useAgreements';
import { useScheduleRequests } from '@/store/useScheduleRequests';
import { useInvoices } from '@/store/useInvoices';
import { storage } from '@/util/firebase';
import { ref as storageRef, getDownloadURL } from 'firebase/storage';
import moment from "moment";
import InvoiceTransactions from './invoice-transactions.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'customer-details',
  props: {
    selection: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const dogs = useDogspace();
const agreements = useAgreements();
const requestStore = useScheduleRequests();
const invoiceStore = useInvoices();
const error = ref<string | null>(null);
const loading = ref({ status: false, type: "" });
const editDog = ref<string>();

const invOpenSet = ref(new Set<string>());

const openDropdown = ref<'dogs' | 'notes' | 'contracts' | 'transactions'>();

const userAgreements = computed(
	() =>
		agreements.asArray.filter(r => r.uids.includes(props.selection.$id))
);
const discountStatus = computed(() => props.selection.discountQualifier);
const name = computed(() => {
	console.log(" %c NAME: ", "outline:1px solid yellow;color:yellow;background-color:black;", props.selection.name);
	if (typeof props.selection?.name === "object") {
		if (props.selection?.name?.fullName?.length) {
			return props.selection?.name?.fullName;
		} else {
			return `${props.selection?.name?.firstName || " "} ${props.selection?.name?.lastName || " "}`;
		}
	} else if (typeof props.selection?.name === "string") {
		return props.selection.name;
	} else {
		return "unknown";
	}
});

const openDocusignEnvelope = async (agreementId: string, status: string) => {
	if (status !== "completed") {
		error.value = "Cannot open incomplete contract";
		return;
	}
	loading.value = { status: true, type: "opening-contract" };
	// console.log("HERE:", agreementId)
	error.value = null;
	const agreement = agreements.requests.get(agreementId);
	if (agreement) {
		console.log("Agreement", agreement);
		
		try {
			let agreementUrl = '';
			if(agreement?.pdfUrl){
				const fileRef = storageRef(storage, agreement?.pdfUrl);

				agreementUrl = await getDownloadURL(fileRef);
			}else{
				const data = await getAgreementUrl({ agreementId: agreement.$id, isSender: true });

				agreementUrl = data.data.url;
			}

			if(!agreementUrl) throw new Error('Unable to access contract');
			window.open(agreementUrl, '_blank');
			loading.value = { status: false, type: "" };
			
		} catch (e) {
			error.value = "Unable to access Contract";
			loading.value = { status: false, type: "" };
		}

	}
	// console.log("HERE 2:", loading.value)
	// loading.value = false;
};


const getTrainingType = (requestId: string) => {
	const request = requestStore.requests.get(requestId);
	if (!request) return null;
	if ('trainingType' in request) {
		return Events.TrainingTypeMap[request.trainingType];
	} else {
		return null;
	}
};

watch(() => props.selection, () => {
	invoiceStore.fetchUserInvoices(props.selection.$id);
});

const __returned__ = { props, dogs, agreements, requestStore, invoiceStore, error, loading, editDog, invOpenSet, openDropdown, userAgreements, discountStatus, name, openDocusignEnvelope, getTrainingType, get DataInstance() { return DataInstance }, Modal, DogCreator, get Events() { return Events }, get Userspaces() { return Userspaces }, ref, computed, onUpdated, watch, DogCard, Dropdown, get useDogspace() { return useDogspace }, UserNotesPanel, get getAgreementUrl() { return getAgreementUrl }, get testAddCustomer() { return testAddCustomer }, get useAgreements() { return useAgreements }, get useScheduleRequests() { return useScheduleRequests }, get useInvoices() { return useInvoices }, get storage() { return storage }, get storageRef() { return storageRef }, get getDownloadURL() { return getDownloadURL }, get moment() { return moment }, InvoiceTransactions }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})